export default __webpack_public_path__ + "static/mstile-144x144-345ae2999c71a4e636b2f21dd20d456b.png";